import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CUSTOMER_FORM_ID } from '../../../global/constants';
import api from '../../../global/api';
import {
  BankType,
  FetchInitialBanksApiResponse,
  FetchOrderBanksApiResponse,
} from './types';

type BankEntity = BankType & { accountNumber?: string };

export const getSellOrderBanks = createAsyncThunk(
  'banks/getSellOrderBanks',
  async (orderId: string) => {
    const { data } = await api.get<FetchOrderBanksApiResponse>(
      `/banks/order/${orderId}`,
    );
    return {
      data,
      orderId,
    };
  },
);

export const initSellOrderBanks = createAsyncThunk(
  'banks/initSellOrderBanks',
  async (orderId: string) => {
    const { data } = await api.get<FetchInitialBanksApiResponse>('/banks');
    return {
      data,
      orderId,
    };
  },
);

export const sellOrderBanksSlice = createSlice({
  name: 'sellOrderBanks',
  initialState: {
    [CUSTOMER_FORM_ID]: [],
  } as Record<string, BankEntity[]>,
  reducers: {
    addSellOrderBank(
      state,
      action: PayloadAction<{ bank: BankType; orderId: string }>,
    ) {
      const { bank, orderId } = action.payload;
      if (state[orderId]) {
        state[orderId].push({
          ...bank,
          temporaryShow: true,
        });
      }
    },
    saveSellOrderBanks(state: any, action: any) {
      const { banks, orderId } = action.payload;
      state[orderId] = [
        ...banks.companyBanks,
        ...banks.internalBanks,
        ...banks.orderBanks,
      ];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(initSellOrderBanks.fulfilled, (state, action) => {
      const { data, orderId } = action.payload;
      state[orderId] = [...data.companyBanks, ...data.internalBanks];
    });
  },
});

export const { addSellOrderBank, saveSellOrderBanks } = sellOrderBanksSlice.actions;
